
import Cpts020 from '@/components/lyx-components/cpts020/index.vue'
import Toast from 'vux/src/components/toast/index.vue'


import bus from '@/javascript/bus'

export default {
components: {
Cpts020,
Toast
},
data() {
return {
minHeight: 0,
tripMode: ['公共交通','自驾'],
tourisType: [],
current: 0,
activeIndex: 1,//存session
visitor: '',
params: JSON.parse(sessionStorage.getItem('historyData')),
showbtn: false,
cityCode: '',
prompt: false,
tripWay:'自驾模式仅支持出发地为海晏县境内城市',
oldVisitorType: '',
oldtransportType: ''
}
},
mounted() {
this.minHeight = document.documentElement.clientHeight
document.title = '行程偏好'
this.cityCode = this.params.startCityCode.slice(0,2)
if (JSON.stringify(this.params) !== '{}' && this.params.travelId) {
this.activeIndex = this.params.transportType
this.current = (this.params.visitorType - 1)
this.visitor = this.params.visitorType
this.oldVisitorType = this.params.visitorType
this.oldtransportType = this.params.transportType



this.showbtn = true
} else if (this.params.visitorType) {
this.oldtransportType = this.params.transportType
this.oldVisitorType = this.params.visitorType
this.activeIndex = this.params.transportType
this.current = (this.params.visitorType - 1)
this.visitor = this.params.visitorType
}
this.typeList()
},
methods: {
addClass: function (item, index) {
this.current = index;
this.visitor = item.id
},
typeList() {
this.$http.get('api/wtcp-recommend/public/travel/visitorType').then((response) => {
this.$set(this, 'tourisType', response.data.data ? response.data.data : [])
})
},
nextStep() {
this.params['transportType'] = this.activeIndex
if(this.visitor == ''){
this.params['visitorType'] = 1
}else{
this.params['visitorType'] = this.visitor
}
if(this.oldVisitorType !== this.visitor){
this.params['changeVisitorType'] = true
}
if(this.oldtransportType !== this.activeIndex){
this.params['changeTransportType'] = true
}
sessionStorage.setItem('historyData', JSON.stringify(this.params))
this.$router.push({path: '/travel-intention'})
},
/*selfDriving() {
this.$router.replace({path: '/travel-choice'})
},*/












creatTrip: function () {
this.params['transportType'] = this.activeIndex
this.params['visitorType'] = this.visitor
sessionStorage.setItem('historyData', JSON.stringify(this.params))
this.$router.push({path: '/data-compute'})
if(this.params.createId && this.params.createId !== bus.userInfo.user.id){
this.$http.get("/getVisitor/citeTemplate?id=" + this.params.travelId[0].nowId + "&userId=" + bus.userInfo.user.id + '&deptCode=' + this.DEPT_CODE.DEPTCODE).then((response) => {

})
}
}
},
}
